import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { Mk8sList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { Mk8sCreateInitializer } from "./create/initializer";
import { Mk8sDetailInitializer } from "./detailInitializer";

const Mk8sRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <div className="dryrun mk8s">
      <Layout key={org}>
        <Routes>
          <Route index element={<Mk8sList />} />
          <Route path={`-create/*`} element={<Mk8sCreateInitializer />} />
          <Route path={`:mk8s/*`} element={<Mk8sDetailInitializer />} />
        </Routes>
      </Layout>
    </div>
  );
};

export default Mk8sRoute;
